import { urls } from "../Reducers/layout";
import DependencyManager from "../../DependencyManager";
import { USER_INTENT, EVALUATION_STATES, USER_VISIT_STATUS_LAYOUT } from "../../Constants/evaluation";
import { paramsToQueryString } from "../../Helpers/url";
import { getLocationId } from "../../Helpers/location";
import { UNKNOWN } from "../../Constants/locations";
import { REQUEST_ORIGIN } from "../../Constants/requestOrigins";
import SessionStorageHelper from "../../Utils/SessionStorageHelper";
import { removeParam } from "../../Utils/UrlHelpers";
import actions from "../../Constants/actions";
import CookieManager from "../../Utils/CookieManager";
import UserSession from "../../Utils/UserSession";
import { LAYOUT_SOURCE } from "../../Constants/layoutSource";
export function setCurrentTab(tabName) {
  var updateSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    if (updateSession) {
      UserSession.setTabName(tabName);
    }
    return dispatch({
      type: actions.SET_CURRENT_TAB,
      data: tabName
    });
  };
}
export function setValuatonRegistraionResponse(res) {
  return function (dispatch) {
    return dispatch({
      type: actions.SET_VALUATION_REGISTRATION_RESPONSE,
      data: res
    });
  };
}
export function fetchLayout(props, laquesisCookie) {
  return function (dispatch, getState, _ref) {
    var get = _ref.get;
    var url = props.viaBFF ? urls.getLayoutViaBFF : urls.getLayout;
    var PanameraConstants = DependencyManager.getDependency('constants');
    var LAYOUT_HEADERS = {
      'X-PANAMERA-CLIENT-ID': "web-".concat(PanameraConstants.platform)
    };
    if (!laquesisCookie) {
      laquesisCookie = CookieManager.readCookie('laquesis');
    }
    if (laquesisCookie) {
      LAYOUT_HEADERS.laquesis = laquesisCookie;
    }
    var _getState = getState(),
      selectedLocation = _getState.locations.selectedLocation,
      _getState$cxeLayout = _getState.cxeLayout,
      isError = _getState$cxeLayout.isError,
      isFetching = _getState$cxeLayout.isFetching,
      layouts = _getState$cxeLayout.layouts,
      tabName = _getState$cxeLayout.tabName,
      _getState$buyerIntent = _getState.buyerIntent,
      _getState$buyerIntent2 = _getState$buyerIntent.filters,
      filters = _getState$buyerIntent2 === void 0 ? {} : _getState$buyerIntent2,
      _getState$buyerIntent3 = _getState$buyerIntent.evaluationState,
      evaluationState = _getState$buyerIntent3 === void 0 ? EVALUATION_STATES.INITIAL : _getState$buyerIntent3;
    var locationId = getLocationId(selectedLocation);
    if (props.userContext && props.layoutSource === LAYOUT_SOURCE.BUYER_INTENT) {
      props.userContext[USER_INTENT.BUYER] = evaluationState || EVALUATION_STATES.INITIAL;
      if (props.userContext.tabName) {
        delete props.userContext.tabName;
        delete props.userContext.seller;
      }
    }
    var params = {
      locationId: props.isPaidCampaign ? UNKNOWN : locationId,
      userContext: props.userContext ? JSON.stringify(props.userContext) : '',
      userVisit: props.userVisit || USER_VISIT_STATUS_LAYOUT.FIRST_TIME,
      channelOfAcquisition: props.channelOfAcquisition ? JSON.stringify(props.channelOfAcquisition) : '',
      requestOrigin: props.layoutSource === 'olxAutos' ? SessionStorageHelper.getItem(REQUEST_ORIGIN) || '' : '',
      lang: props.lang,
      additionalData: props.additionalData ? JSON.stringify(props.additionalData) : JSON.stringify(Object.assign(Object.assign({}, filters), {
        locationId: locationId
      }))
    };
    var urlPath = url(props.layoutSource);
    var fullUrl = "".concat(urlPath, "?").concat(paramsToQueryString(params));
    var urlToFind = removeParam('userVisit', fullUrl);
    if (!tabName && props.userContext.tabName) {
      dispatch(setCurrentTab(props.userContext.tabName));
    }
    if (isError[urlToFind] || isFetching[urlToFind] || layouts[urlToFind]) {
      return dispatch({
        type: actions.SET_LAYOUT_EXIST,
        data: true
      });
    }
    return dispatch(get(urlPath, 'CXE_LAYOUT', params, LAYOUT_HEADERS)).then(function () {
      return dispatch({
        type: actions.SET_LAYOUT_EXIST,
        data: false
      });
    });
  };
}
export default fetchLayout;